//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pieCharts from '~/components/home/fundsFlowdatails/pieCharts.vue'
export default {
  components: {
    'pie-charts': pieCharts
  },
  props: {
    fundsMovementData: {
      type: Object,
      default: () => {}
    },
    trendForPrice: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      turnoverTime: '', // 更新时间
      explain: '',
      fundsMovement: [{
        prop_long: '0%',
        prop_short: '0%'
      }, {
        prop_long: '0%',
        prop_short: '0%'
      }, {
        prop_long: '0%',
        prop_short: '0%'
      }, {
        prop_long: '0%',
        prop_short: '0%'
      }],
      matchupArr: [{ user_type: 1, name: '28778', color: '#6FC69F' }, { user_type: 2, name: '28777', color: '#E59460' }, { user_type: 3, name: '28779', color: '#3B76F6' }, { user_type: 4, name: '28780', color: '#8D81F3' }],
      pieColorArray: ['#6FC69F', '#E59460', '#3B76F6', '#8D81F3']
    }
  },
  mounted () {
    this.getFundMovementData(this.fundsMovementData, this.trendForPrice)
  },
  methods: {
    getFundMovementData (fundsMovementData, trendForPrice) {
      const { FundsMovement: fundsMovement = [], explain = '' } = fundsMovementData
      const { trendForPrice: lineList = [] } = trendForPrice
      if (lineList?.length) this.turnoverTime = lineList[0].create_at
      this.explain = explain
      const lotsLongMax = Math.max.apply(Math, fundsMovement.map((it) => { return Math.floor(it.lots_long) }))
      const lotsShortMax = Math.max.apply(Math, fundsMovement.map((it) => { return Math.floor(it.lots_short) }))
      fundsMovement?.forEach((item) => {
        item.symbol = item.user_type
        item.value = item.tradenum
        item.lots_long = Math.floor(item.lots_long)
        item.lots_short = Math.floor(item.lots_short)
        item.prop_long = Math.floor((item.lots_long / lotsLongMax) * 100) + '%'
        item.prop_short = Math.floor((item.lots_short / lotsShortMax) * 100) + '%'
      })
      this.fundsMovement = fundsMovement || []
    }
  }
}
